import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const RewardFormContext = createContext();

const RewardFormContextProvider = ({ children }) => {
  const [country, setCountry] = useState({});
  return (
    <RewardFormContext.Provider value={{ country, setCountry }}>
      {children}
    </RewardFormContext.Provider>
  );
};

RewardFormContextProvider.propTypes = {
  children: PropTypes.node,
};

export default RewardFormContextProvider;
